// react-query cache keys of Inicio.
export const humanTasksKeys = {
  all: ['human-tasks'],
  me: () => [...humanTasksKeys.all, 'me'],
  myStats: (range) => [...humanTasksKeys.all, 'stats', 'me', range],
  teamStats: (range) => [...humanTasksKeys.all, 'stats', 'team', range],
};

export default humanTasksKeys;
